import { v4 } from 'uuid';

export const uuid = ({ withPrefix = true, length = 8 } = {}) => {
  if (length > 36) throw 'uuid length cannot be greater than 36';
  const prefix = withPrefix ? '_' : '';
  return prefix + v4().substring(0, length);
};
